module.exports = __webpack_public_path__ + "view/img/code.d3a6869.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code.jpg
// module id = 24Xq
// module chunks = 13